import type {
  Onboarding,
  OnboardingVersion,
} from '@modules/firebase-core/converters/onboardingConverter';

export const DEFAULT_WEB_PLACEMENT_SCHEMA_VERSION = '2.0.0';

export function getExplicitSchemaVersion(version: Pick<OnboardingVersion, 'screensGraph'> | null | undefined): string {
  return version?.screensGraph?.schemaVersion ?? '';
}

export function isV2SchemaVersion(schemaVersion: string): boolean {
  return schemaVersion.startsWith('2.');
}

export function inferV2SchemaVersionFromParent(onboarding: Pick<Onboarding, 'screenGraphType'> | null | undefined): string | null {
  return onboarding?.screenGraphType === 'v2'
    ? DEFAULT_WEB_PLACEMENT_SCHEMA_VERSION
    : null;
}
